<template>
  <svg class="training-instruction-count-icon"
       viewBox="0 0 24 24"
       fill="none"
       stroke="currentColor"
       stroke-width="2"
       stroke-linecap="round"
       stroke-linejoin="round"
       aria-hidden="true">
    <template v-if="name === 'book-open'">
      <path d="M12 7v14" />
      <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
    </template>
    <template v-else-if="name === 'file-pen'">
      <path d="M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'TrainingInstructionCountIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: value => ['book-open', 'file-pen'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.training-instruction-count-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/training/components/TrainingInstructionCountIcon.vue